<script>
    import mixin from './../mixin';
    import SourceSet from './SourceSet.vue';

    export default {
        components: { SourceSet },
        mixins: [mixin],
        emits: ['toggleVodFavourite'],
        methods: {
            toggleVodFavourite(id) {
                this.$emit('toggleVodFavourite', id);
            }
        },
        props: {
            item: Object,
            favouriteTitleAdd: {
                type: String,
                default: 'Voeg toe aan favorieten'
            },
            favouriteTitleRemove: {
                type: String,
                default: 'Verwijder van favorieten'
            },
            isLoggedIn: {
                type: Boolean,
                default: false
            },
            isAvailable: {
                type: Boolean,
                default: true
            },
            unavailableLabel: {
                type: String,
                default: 'Niet beschikbaar'
            },
            availableLabel: {
                type: String,
                default: 'Beschikbaar'
            },
            culture: {
                type: String,
                default: 'nl-NL'
            }
        }
    }
</script>

<template>
    <div class="image-link-visual is-relative">
        <template v-if="item.imageSets && item.imageSets.length">
            <source-set :imageSets="item.imageSets" imageClass="image-link-image image" />
        </template>
        <picture class="image-link-image image-link-image-fallback" v-else>
            <img src="/svg/EMTV-logo.svg" alt="no image">
        </picture>
            <span :class="['wishlist-add', 'has-text-secondary', 'wishlist-'+item.id, item.favourite ? 'is-active' : '']" :data-eventid="item.id" 
                                                                                          :data-add="favouriteTitleAdd" 
                                                                                          :data-remove="favouriteTitleRemove"
                                                                                          :title="item.favourite ? favouriteTitleRemove : favouriteTitleAdd" 
                                                                                          :id="item.id"
                                                                                          @click.prevent.stop="toggleVodFavourite(item.id)" v-if="isLoggedIn">
            <span class="icon">
                <i class="fa-regular fa-heart fa-xl"></i>
                <i class="fa-solid fa-heart fa-xl"></i>
            </span>
        </span>
    </div>
    <div class="image-link-content">
        <span class="image-link-date" v-if="!isAvailable">{{ unavailableLabel }}</span>
        <time :datetime="item.earliestViewableStart" class="image-link-date" v-else-if="toDateObj(item.earliestViewableStart) > new Date()">
            <span class="is-hidden-widescreen-only">{{ availableLabel }}</span> {{ toDateTime(item.earliestViewableStart, culture) }}
        </time>
        <h3 class="title mb-2" v-if="item.title">{{ item.title }}</h3>
        <h4 class="title mb-2" v-if="item.concertName">{{ item.concertName }}</h4>
        <p v-if="item.listDescription">{{ item.listDescription }}</p>
    </div>
</template>